import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { SubmitChallenge } from './submitChallenge.type';
import { addChallengeApi, getSignedUrlApi } from './submitChallenge.apis';
import { enqueueSnackbar } from 'notistack';
import { ERRORS } from '&config/constants';

const initialState: SubmitChallenge = {
	loading: false,
	loadingUpload: false,
	status: '',
	signedUrl: '',
};

const addChallenge = createAsyncThunk(
	'submitChallenge/addChallenge',
	async (body: any, { rejectWithValue, getState }: any) => {
		try {
			const response = await addChallengeApi(body);

			return response;
		} catch (e: any) {
			let error = 'Something went wrong, please try again later';
			if (ERRORS[e.response.data.message]) {
				error = ERRORS[e.response.data.message];
			}
			enqueueSnackbar(error, {
				autoHideDuration: 3000,
				variant: 'error',
			});
			return rejectWithValue(e);
		}
	}
);

const getSignedUrl = createAsyncThunk(
	'submitChallenge/getSignedUrl',
	async (body: any, { rejectWithValue, getState }: any) => {
		try {
			const response = await getSignedUrlApi(body);
			return response;
		} catch (e) {
			return rejectWithValue(e);
		}
	}
);

const submitChallengeSlice = createSlice({
	name: 'submitChallenge',
	initialState: initialState,
	reducers: {
		setSubmitChallenge: (state, action) => {
			return { ...state, ...action.payload };
		},
		reset: () => initialState,
	},

	extraReducers: (builder) => {
		builder.addCase(addChallenge.pending, (state, action) => {
			state.loading = true;
		});
		builder.addCase(addChallenge.fulfilled, (state, action) => {
			state.loading = false;
			state.status = 'CHALLENGE_ADDED_SUCCESSFULLY';
		});
		builder.addCase(addChallenge.rejected, (state, action) => {
			state.loading = false;
		});
		builder.addCase(getSignedUrl.pending, (state, action) => {
			state.loadingUpload = true;
		});
		builder.addCase(getSignedUrl.fulfilled, (state, action) => {
			state.loadingUpload = false;
			state.status = 'URL_FETCHED_SUCCESSFULLY';
			state.signedUrl = action.payload;
		});
		builder.addCase(getSignedUrl.rejected, (state, action) => {
			state.loadingUpload = false;
		});
	},
});

export const submitChallengeReducer = submitChallengeSlice.reducer;

export const submitChallengeActions = {
	...submitChallengeSlice.actions,
	addChallenge,
	getSignedUrl,
};
